import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { convertToStringIndex } from "../Contractors/ContractorDetails";

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 30,
    backgroundColor: "#FFFFFF",
  },
  header: {
    marginBottom: 20,
    borderBottomWidth: 1,
    borderBottomColor: "#CCCCCC",
    paddingBottom: 10,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  headerLeft: {
    flexDirection: "column",
  },
  title: {
    fontSize: 22,
    fontWeight: "bold",
    color: "#46237A",
  },
  subtitle: {
    fontSize: 12,
    color: "#666666",
    marginTop: 5,
  },
  section: {
    marginBottom: 15,
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 5,
    color: "#333333",
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
    paddingVertical: 3,
    borderBottomWidth: 1,
    borderBottomColor: "#EEEEEE",
  },
  label: {
    fontSize: 10,
    color: "#666666",
  },
  value: {
    fontSize: 10,
    textAlign: "right",
  },
  totalRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10,
    paddingTop: 10,
    borderTopWidth: 1,
    borderTopColor: "#000000",
  },
  totalLabel: {
    fontSize: 12,
    fontWeight: "bold",
  },
  totalValue: {
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "right",
  },
  footer: {
    marginTop: 30,
    borderTopWidth: 1,
    borderTopColor: "#CCCCCC",
    paddingTop: 10,
    fontSize: 8,
    color: "#999999",
    textAlign: "center",
  },
  itemRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottomWidth: 1,
    borderBottomColor: "#EEEEEE",
    paddingVertical: 5,
  },
  itemName: {
    fontSize: 10,
    width: "40%",
  },
  itemDescription: {
    fontSize: 9,
    color: "#666666",
    width: "25%",
  },
  itemQty: {
    fontSize: 10,
    width: "15%",
    textAlign: "center",
  },
  itemPrice: {
    fontSize: 10,
    width: "20%",
    textAlign: "right",
  },
  remark: {
    marginTop: 20,
    padding: 10,
    backgroundColor: "#F9F9F9",
  },
  remarkText: {
    fontSize: 9,
    color: "#666666",
    fontStyle: "italic",
  },
  receiptImage: {
    marginTop: 10,
    width: 200,
    height: 200,
    objectFit: "cover",
  },
});

const ReceiptPDF = ({ transactionData, type }) => {
  const formatDate = (dateString) => {
    try {
      return new Date(dateString).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    } catch {
      return "N/A";
    }
  };

  const getReceiptTitle = () => {
    switch (type) {
      case "material":
        return "Material Purchase Receipt";
      case "worker":
        return "Worker Payment Receipt";
      case "refund":
        return "Refund Receipt";
      case "other":
        return "Transaction Receipt";
      case "vendor":
        return "Vendor Payment Receipt";
      case "contractor":
        return "Contractor Payment Receipt";
      default:
        return "Transaction Receipt";
    }
  };

  const receiptNumber = `RC-${transactionData.transaction_id}`;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <View style={styles.headerLeft}>
            <Text style={styles.title}>{getReceiptTitle()}</Text>
            <Text style={styles.subtitle}>
              {transactionData.site_name ? (
                <>
                  Site Name:{" "}
                  <Text style={{ fontWeight: "bold", color: "#333333" }}>
                    {transactionData.site_name}
                  </Text>
                </>
              ) : (
                <Text style={{ fontWeight: "bold", color: "#333333" }}>
                  Organization Purchase
                </Text>
              )}
            </Text>
            <Text style={styles.subtitle}>Receipt No: {receiptNumber}</Text>
            <Text style={styles.subtitle}>
              Date:{" "}
              {formatDate(
                transactionData.date ||
                transactionData.transaction_date ||
                transactionData.created_on
              )}
            </Text>
          </View>
        </View>

        {/* Transaction Details */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Transaction Details</Text>
          {type === "material" && (
            <>
              <View style={styles.row}>
                <Text style={styles.label}>Vendor/Shop</Text>
                <Text style={styles.value}>
                  {transactionData.vendor_name || "N/A"}
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Contact</Text>
                <Text style={styles.value}>
                  {transactionData.vendor_contact}
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Payment Method</Text>
                <Text style={styles.value}>
                  {transactionData.method || "N/A"}
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Payment Status</Text>
                <Text style={styles.value}>
                  {transactionData.status || "N/A"}
                </Text>
              </View>
            </>
          )}
          {type === "worker" && (
            <>
              <View style={styles.row}>
                <Text style={styles.label}>Worker Name</Text>
                <Text style={styles.value}>
                  {transactionData.worker_name || "N/A"}
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Work Type</Text>
                <Text style={styles.value}>
                  {transactionData.worker_workname || "N/A"}
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Contact</Text>
                <Text style={styles.value}>
                  {transactionData?.worker_contact || "N/A"}
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Created By</Text>
                <Text style={styles.value}>
                  {transactionData.created_by || "N/A"}
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Payment Method</Text>
                <Text style={styles.value}>
                  {transactionData.method || "N/A"}
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Payment Type</Text>
                <Text style={styles.value}>
                  {transactionData.payment_type || "N/A"}
                </Text>
              </View>
            </>
          )}
          {type === "refund" && (
            <>
              <View style={styles.row}>
                <Text style={styles.label}>Transaction Type</Text>
                <Text style={styles.value}>{"Refund"}</Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Purpose of Refund</Text>
                <Text style={styles.value}>
                  {transactionData.original_transaction_type || "N/A"}
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Refund Method</Text>
                <Text style={styles.value}>
                  {transactionData.method || "N/A"}
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Refund Status</Text>
                <Text style={styles.value}>
                  {transactionData.status || "N/A"}
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Remarks</Text>
                <Text style={styles.value}>
                  {transactionData.comments || "N/A"}
                </Text>
              </View>
            </>
          )}
          {type === "other" && (
            <>
              <View style={styles.row}>
                <Text style={styles.label}>Transaction Type</Text>
                <Text style={styles.value}>
                  {transactionData.description || "N/A"}
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Created By</Text>
                <Text style={styles.value}>
                  {transactionData.created_by || "N/A"}
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Payment Method</Text>
                <Text style={styles.value}>
                  {transactionData.method || "N/A"}
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Created On</Text>
                <Text style={styles.value}>
                  {formatDate(transactionData.created_on) || "N/A"}
                </Text>
              </View>
            </>
          )}

          {type === "vendor" && (
            <>
              <View style={styles.row}>
                <Text style={styles.label}>Vendor Name</Text>
                <Text style={styles.value}>
                  {transactionData.vendor_name || "N/A"}
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Contact</Text>
                <Text style={styles.value}>
                  {transactionData.vendor_contact || "N/A"}
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Payment Method</Text>
                <Text style={styles.value}>
                  {transactionData.method || "N/A"}
                </Text>
              </View>
            </>
          )}
          {type === "contractor" && (
            <>
              <View style={styles.row}>
                <Text style={styles.label}>Contractor Name</Text>
                <Text style={styles.value}>
                  {transactionData.contractor_name || "N/A"}
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Work Order</Text>
                <Text style={styles.value}>
                  {transactionData.description || "N/A"}
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Payment Method</Text>
                <Text style={styles.value}>
                  {transactionData.method || "N/A"}
                </Text>
              </View>
            </>
          )}
        </View>

        {/* Material List */}
        {type === "material" && transactionData.all_materials?.length > 0 && (
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Materials</Text>
            <View style={styles.itemRow}>
              <Text style={[styles.itemName, { fontWeight: "bold" }]}>
                Material
              </Text>
              <Text style={[styles.itemDescription, { fontWeight: "bold" }]}>
                Category
              </Text>
              <Text style={[styles.itemQty, { fontWeight: "bold" }]}>
                Quantity
              </Text>
              <Text style={[styles.itemQty, { fontWeight: "bold" }]}>
                Unit Price
              </Text>
              <Text style={[styles.itemPrice, { fontWeight: "bold" }]}>
                Total Price
              </Text>
            </View>
            {transactionData.all_materials.map((m, i) => (
              <View style={styles.itemRow} key={i}>
                <Text style={styles.itemName}>
                  {m.material_name || m.name || "N/A"}
                </Text>
                <Text style={styles.itemDescription}>
                  {m.material_subcategory ||
                    m.category ||
                    m.material_category ||
                    "N/A"}
                </Text>
                <Text style={styles.itemQty}>
                  {m.quantity || m.qty || 0} {m.unit || m.unit_type || ""}
                </Text>
                <Text style={styles.itemQty}>
                  Rs. {m.unit_price?.toLocaleString() || "0"}
                </Text>
                <Text style={styles.itemPrice}>
                  Rs.{" "}
                  {m.total_price?.toLocaleString() ||
                    m.price?.toLocaleString() ||
                    "0"}
                </Text>
              </View>
            ))}
          </View>
        )}

        {/* Payment Details */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Payment Summary</Text>

          {type === "material" && (
            <>
              <View style={styles.row}>
                <Text style={styles.label}>Total Amount</Text>
                <Text style={styles.value}>
                  Rs. {transactionData.total_price?.toLocaleString() || "0"}
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Paid Amount</Text>
                <Text style={styles.value}>
                  Rs. {transactionData.paid_amount?.toLocaleString() || "0"}
                </Text>
              </View>
              {/* <View style={styles.row}>
                <Text style={styles.label}>Remaining Amount</Text>
                <Text style={styles.value}>
                  Rs.{" "}
                  {transactionData.remaining_payment?.toLocaleString() || "0"}
                </Text>
              </View> */}
            </>
          )}

          {(type === "worker" ||
            type === "refund" ||
            type === "other" ||
            type === "vendor" ||
            type === "contractor") && (
              <>
                <View style={styles.row}>
                  <Text style={styles.label}>Amount</Text>
                  <Text style={styles.value}>
                    Rs. {transactionData.amount?.toLocaleString() || "0"}
                  </Text>
                </View>
              </>
            )}

          <View style={styles.totalRow}>
            <Text style={styles.totalLabel}>Total Payment</Text>
            <Text style={styles.totalValue}>
              Rs.{" "}
              {(type === "material"
                ? transactionData.paid_amount
                : transactionData.amount
              )?.toLocaleString() || "0"}
            </Text>
          </View>
        </View>

        {/* Remarks */}
        {transactionData.comments && (
          <View style={styles.remark}>
            <Text style={styles.sectionTitle}>Remarks</Text>
            <Text style={styles.remarkText}>{transactionData.comments}</Text>
          </View>
        )}

        {/* Receipt Images */}
        {((transactionData.receipt_image &&
          transactionData.receipt_image.length !== 0) ||
          transactionData.receipt_url) && (
            <View style={styles.section}>
              <Text style={styles.sectionTitle}>Receipt Image</Text>
              {(() => {
                let images = [];
                if (transactionData.receipt_image) {
                  images = Array.isArray(transactionData.receipt_image)
                    ? transactionData.receipt_image
                    : [transactionData.receipt_image];
                } else if (transactionData.receipt_url) {
                  images = [transactionData.receipt_url];
                }
                return images.map((imgSrc, idx) => (
                  <Image key={idx} src={imgSrc} style={styles.receiptImage} />
                ));
              })()}
            </View>
          )}

        <View style={styles.footer}>
          <Text>
            This is a computer-generated receipt and does not require signature.
          </Text>
          <Text>For any queries, please contact support.</Text>
        </View>
      </Page>
    </Document>
  );
};

export default ReceiptPDF;
